import { render, staticRenderFns } from "./describe.vue?vue&type=template&id=639e0fdf&scoped=true"
import script from "./describe.vue?vue&type=script&lang=js"
export * from "./describe.vue?vue&type=script&lang=js"
import style0 from "./describe.vue?vue&type=style&index=0&id=639e0fdf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639e0fdf",
  null
  
)

export default component.exports